// src/pages/Relatorios/RelatoriosPage.tsx

import AssessmentIcon from '@mui/icons-material/Assessment';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { ThemeProvider } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import QCXMainLayout from '../../../components/main-layout/QCXMainLayout';
import CardsModalGrid, { CardsModalGridItem } from '../../common/components/cardsGrid/cardsModalGrid';
import theme from '../../common/themes/theme';
import AguardandoChegadaPage from './aguardandoChegada/AguardandoChegadaPage';
import AguardandoRegistroPage from './aguardandoRegistro/AguardandoRegistroPage';
import AguardandoDesembaracoPage from './aguardandoDesembaraco/aguardandoDesembaracoPage';
import AguardandoFaturamentoPage from './aguardandoFaturamento/aguardandoFaturamentoPage';
import RelatorioControleDADialog from './declaracaoAduaneiraReport/RelatorioControleDADialog';
import RelatorioProcessosRefPage from '../relatorios/relatorioProcessosRef/relatorioProcessosRefPage';
import RelatorioItensDiPage from '../relatorios/relatorioItensDi/relatorioItensDiPage';
import AcompanhamentoChegadaPage from './acompanhamentoChegada/AcompanhamentoChegadaPage';
import KpiImportacaoPage from './kpiImportacao/kpiImportacaoPage';
const exportacaoModalGridItems: CardsModalGridItem[] = [
  {
    title: 'Aguardando Chegada Mercadoria',
    icon: InsertDriveFileIcon,
    modalName: 'AGUARDANDO_CHEGADA',
    modalComponent: AguardandoChegadaPage,
  },
  {
    title: 'Aguardando Registro',
    icon: InsertDriveFileIcon,
    modalName: 'AGUARDANDO_REGISTRO',
    modalComponent: AguardandoRegistroPage,
  },
  {
    title: 'Aguardando Desembaraco',
    icon: InsertDriveFileIcon,
    modalName: 'AGUARDANDO_DESEMBARACO',
    modalComponent: AguardandoDesembaracoPage,
  },
  {
    title: 'Relatório de Controle de Declarações Aduaneiras',
    icon: InsertDriveFileIcon,
    modalName: 'RELATORIO_CONTROLE_DA',
    modalComponent: RelatorioControleDADialog,
  },
  {
    title: 'Resumo Processos Registrados',
    icon: InsertDriveFileIcon,
    modalName: 'RESUMO_PROCESSOS_REGISTRADOS',
    modalComponent: RelatorioProcessosRefPage,
    requiredRoles: ['relatorio-processos-ref-visualizar'],
  },
  {
    title: 'Relatório Itens DI',
    icon: InsertDriveFileIcon,
    modalName: 'RELATORIO_ITENS_DI',
    modalComponent: RelatorioItensDiPage,
    requiredRoles: ['relatorio-itens-di-visualizar'],
  },
  {
    title: 'Acompanhamento de Chegada',
    icon: InsertDriveFileIcon,
    modalName: 'ACOMPANHAMENTO_CHEGADA',
    modalComponent: AcompanhamentoChegadaPage,
    requiredRoles: ['relatorio-acompanhamento-chegada-visualizar'],
  },
  {
    title: 'KPI Importação',
    icon: InsertDriveFileIcon,
    modalName: 'KPI_IMPORTACAO',
    modalComponent: KpiImportacaoPage,
    requiredRoles: ['relatorio-kpi-importacao-visualizar'],
  },
];

const ImportacaoRelatoriosPage: React.FC = ({ authInfo = {} }: any) => {
  const { t } = useTranslation();

  const [reportOpenName, setReportOpenName] = useState('');
  const closeOpenReport = () => setReportOpenName('');
  const openReportByName = (name: string) => () => setReportOpenName(name);

  return (
    <ThemeProvider theme={theme}>
      <QCXMainLayout
        key="main-layout"
        pageTitle={'Relatórios de Importação'}
        pageIcon={<AssessmentIcon color={'secondary'} />}
        breadcrumbs={[
          { link: { to: '/', name: t('com.muralis.qcx.inicio') } },
          { link: { to: '/importacao', name: 'Importação' } },
          { text: { name: 'Relatórios de Importação' } },
        ]}
        authInfo={authInfo}
      >
        <CardsModalGrid
          items={exportacaoModalGridItems}
          modalOpenName={reportOpenName}
          openModalByName={openReportByName}
          closeModal={closeOpenReport}
        />
      </QCXMainLayout>
    </ThemeProvider>
  );
};

export default ImportacaoRelatoriosPage;
